import { logoutUrl } from "../../config";
import HttpClient from "../../utils/http";

export function adminLogout() {
  return HttpClient.delete(logoutUrl);
}
